import { copyToClipboard } from '~src/broadcasts/components/PublicFacingUrlCopyButton';
import { Messages } from '~src/codegen/Localize';
import { IDataSourceInfo } from '~src/datasource/models/IDataSourceInfo';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

export const CopyLuidEntityAction: IEntityAction<IContentInfo<'datasource'>, {}> = {
  name: EntityActionNames.CopyLuid,
  translateName: Messages.luidCopyAction,
  isVisible: (targetItems: IContentInfo[]) => {
    return targetItems.length === 1 && !!(targetItems[0] as IDataSourceInfo).luid;
  },
  isClickable: (_availableActions: {}, targetItems: IContentInfo[]) => {
    return targetItems.length === 1 && !!(targetItems[0] as IDataSourceInfo).luid;
  },
  createReduxAction: (targetItems: IContentInfo[]) => {
    copyToClipboard((targetItems[0] as IDataSourceInfo).luid, Messages.luidCopied());
    return undefined;
  }
};
